import { useState as a } from "react";
const c = typeof localStorage < "u";
function u(t, o) {
  const [n, s] = a(() => {
    if (typeof window > "u")
      return o;
    try {
      const e = window.localStorage.getItem(t);
      return e ? JSON.parse(e) : o;
    } catch (e) {
      return console.error(`Error: ${e instanceof Error ? e.message : e}`), o;
    }
  });
  return [n, (e) => {
    try {
      const r = e instanceof Function ? e(n) : e;
      s(r), typeof window < "u" && window.localStorage.setItem(t, JSON.stringify(r));
    } catch (r) {
      console.error(`Error: ${r instanceof Error ? r.message : r}`);
    }
  }, c];
}
export {
  c as i,
  u
};
